import simpleParallax from 'simple-parallax-js/vanilla';

export const initializeParallax = () => {
    const images = document.querySelectorAll('.js-parallax');

    images.forEach((item) => {
        const scale = parseFloat(item.getAttribute('data-scale')) || 1.4;
        const delay = parseFloat(item.getAttribute('data-delay')) || 0.4;
        const orientation = item.getAttribute('data-orientation') || 'down';

        new simpleParallax(item, {
            scale: scale,
            delay: delay,
            orientation: orientation
        });
    });
};

initializeParallax(); 